import React, { useEffect, useState } from "react";
import { LysaDoc } from "@lysaab/docs";
import { Spinner } from "../spinner/Spinner";
import { Select } from "../select/Select";
import "./Docs.scss";
export const Docs = ({ variableValues, selectPlaceholder, docName, validatedDocuments, }) => {
    const [alternatives, setAlternatives] = useState();
    const [selectedDocument, setSelectedDocument] = useState();
    useEffect(() => {
        var _a;
        let isMounted = true;
        const alternatives = validatedDocuments.map((doc) => {
            return {
                text: doc.title,
                value: doc.fileName,
            };
        });
        if (!isMounted) {
            return;
        }
        setAlternatives(alternatives);
        const selectedDoc = (_a = alternatives.find((alt) => alt.value === docName)) !== null && _a !== void 0 ? _a : alternatives[0];
        if (selectedDoc) {
            setSelectedDocument(selectedDoc);
        }
        return () => {
            isMounted = false;
        };
    }, [docName, validatedDocuments]);
    return (React.createElement("div", { className: "lysa-ui-doc-modal-docs" },
        !alternatives && React.createElement(Spinner, null),
        alternatives && (React.createElement(React.Fragment, null,
            alternatives.length > 1 && (React.createElement(Select, { alternatives: alternatives, onChange: (alternative) => setSelectedDocument(alternative), value: selectedDocument, placeholder: selectPlaceholder || "", label: "" })),
            React.createElement(LysaDoc, { path: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.value, variableValues: variableValues })))));
};
